import { rootUrl } from "./global"

export const getJwtToken = (email, password) => rootUrl.post('/auth/login?version=v1', {email, password})

export const viewDashboard = () => rootUrl.get('/report/dashboard?version=v2')

export const searchCandidateData = (startDate, endDate) => rootUrl.get(`/export/candidate?version=v1&startDate=${startDate}&endDate=${endDate}`)


export const showProjects = () => rootUrl.get('/project/all?version=v1')

export const updateProject = (project) => rootUrl.put(`/project?version=v1`, project)

export const createProject = (projectData) => rootUrl.post(`/project?version=v1`, projectData)

export const getProjectById = (id) => rootUrl.get(`/project/${id}?version=v1`)

export const showUsers = () => rootUrl.get('/user?version=v1')

export const updateUser = (user) => rootUrl.put(`/user?version=v1`, user)

export const createUser = (userData) => rootUrl.post(`/user?version=v1`, userData)

export const getUser = (id) => rootUrl.get(`/user/${id}?version=v1`);

export const getState = () => rootUrl.get('/list/state?version=v1')

export const getJobrole = () => rootUrl.get('/list/jobrole?version=v1')

// export const getCandidateByProject = (projectId, page = 0, size = 10, search) => 
//   rootUrl.get(`/enroll/project/${projectId}?version=v1&page=${page}&size=${size}&search=${search}`);

export const getCandidateByProject = (projectId, page = 0, size = 10, search = "") => {
  let url = `/enroll/project/${projectId}?version=v1&page=${page}&size=${size}`;
  if (search && search.trim() !== "") {
    url += `&search=${encodeURIComponent(search)}`;
  }
  console.log("getCandidateByProject ->", url);
  return rootUrl.get(url);
};


export const createBatch = (batchData) => rootUrl.post(`/batch?version=v1`, batchData)

//export const updateBatch = (batchData) => rootUrl.post(`/batch?version=v1`, batchData)

// export const updateBatch = (data) =>
//   fetch(`${rootUrl}/batch?version=v1`, {
//     method: "POST", // always POST
//     headers: {
//       "Content-Type": "application/json",
//     },
//     body: JSON.stringify(data),
//   });

export const selectTPName = () => rootUrl.get(`/user/tp?version=v1`);

// export const createEvidence = (evidenceData) => {
//   return rootUrl.post(`/evidence/${batchId}?version=v1`, evidenceData);
// };
export const createEvidence = (evidenceData) => {
  return rootUrl.post(`/evidence?version=v1`, evidenceData);
};

export const uploadFile = (filedata) => rootUrl.post(`/cloud/upload?version=v1`, filedata)

export const getBatchesByProject = (projectId, page = 0, size = 10) => {
  return rootUrl.get(`/batch/project/web/${projectId}?version=v1&page=${page}&size=${size}`);
};

export const fetchBatchById = async (batchId) => {
  return await rootUrl.get(`/batch/${batchId}?version=v1`);
};

export const fetchEvidenceById = async (batchId, page = 0, size = 10) => {
  return await rootUrl.get(`/evidence/batch/web/${batchId}?version=v1&page=${page}&size=${size}`);
};

export const getEvidenceById = async (evidenceId) => {
  return await rootUrl.get(`/evidence/${evidenceId}?version=v1`);
};

// export const evidenceFile = (fileName) => {
//     return rootUrl.get(`/cloud/download?version=v1&keyName=${fileName}`, {
//         responseType: 'arraybuffer',
//     });
// };

export const evidenceFile = (fileName) => {
  if (!fileName) throw new Error("File name is required for download.");
  return rootUrl.get(
    `/cloud/download?version=v1&keyName=${encodeURIComponent(fileName)}`,
    {
      responseType: "blob", // blob is better than arraybuffer for browser downloads
    }
  );
};

export const downloadFile = (keyName) => {
  if (!keyName) throw new Error("File key is required for download.");
  return rootUrl.get(
    `/cloud/download?version=v1&keyName=${encodeURIComponent(keyName)}`,
    { responseType: "blob" }
  );
};


// Candidate API endpoints
// export const addCandidate = (candidateData) => {
//   return rootUrl.post("/enroll/candidate?version=v1", candidateData);
// };
export const addCandidate = (data) =>
  rootUrl.post(`/enroll/candidate?version=v1`, data);

// export const getCandidateByAadharAndProject = (aadhar, projectId) => {
//   return rootUrl.get(`/candidate/${aadhar}/${projectId}?version=v1`);
// };

export const getCandidateByAadharAndProject = (aadhar, projectId) => {
  return rootUrl.get(`/enroll/candidate/${aadhar}/${projectId}?version=v1`);
};

export const updateCandidate = (candidate) => {
  return rootUrl.post(`/enroll/candidate?version=v1`, candidate);
};



// export const uploadCandidates = (projectId, file) => {
//   const fd = new FormData();
//   fd.append("file", file);
//   fd.append("projectId", projectId);

//   return rootUrl.post("/candidate/upload", fd, {
//     headers: { "Content-Type": "multipart/form-data" },
//   });
// };

export const uploadCandidatesCSV = (file, projectId, rollbackAllOnFailure = true) => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("rollbackAllOnFailure", rollbackAllOnFailure);

  return rootUrl.post(
    `/enroll/candidates/batch/csv/${projectId}?version=v1`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
};





